import React, { useEffect } from "react";
import { Form, Drawer, notification } from "../../components/Elements/appUtils";
import axios from "axios";
import { GetEachFormFields, } from "../../components/_utils/formUtils";
import { getToken } from "../../request";
import { updateMainMenuUrl } from "./api";

function EditMainMenu(props) {
    const { visible, editData, onClose, reloadTable, form } = props;

    useEffect(() => {
        if (visible && editData?._id) {
            form.setFieldsValue({
                mainMenuName: editData.mainMenuName || "",
                isNewDesign: editData.isNewDesign ?? false,
            });
        }
    }, [visible, editData?._id]);

    const resetAndClose = () => {
        form.resetFields();
        onClose();
    };

    const handleUpdate = (e) => {
        e.preventDefault();

        form.validateFields(async (err, valData) => {
            if (err) return;

            const payload = {
                ...valData,
                status: editData?.status || "Active",
                isDefault: editData?.isDefault || false,
            };
            console.log("PAYLOAD BEING SENT =>", payload);

            try {
                const response = await axios.put(
                    updateMainMenuUrl(editData._id),
                    payload,
                    getToken()
                );

                if (response.data.success) {
                    notification.success({
                        message: response.data.message || "Updated successfully",
                    });

                    form.resetFields();
                    onClose();
                    reloadTable();
                } else {
                    notification.error({
                        message: response.data.message || "Something went wrong",
                    });
                }
            } catch (error) {
                console.log(error);
                notification.error({
                    message: error?.response?.data?.message || "Request failed",
                });
            }
        });
    };

    const inputTypes = {
        fields: [
            {
                key: "mainMenuName",
                label: "Main Menu Name",
                span: "col-md-12",
                placeholder: "Enter Main Menu Name",
                type: "text",
            },
            {
                key: "isNewDesign",
                label: "New Design",
                span: "col-md-12",
                placeholder: "Select New Design",
                type: "select",
                keyAccessor: (val) => val.value,
                valueAccessor: (val) => val.display,
                options: [
                    { value: true, display: "Yes" },
                    { value: false, display: "No" },
                ],
                onChange: (val) => {
                    form.setFieldsValue({ isNewDesign: val === true || val === "true" });
                },
                required: true,
            },,
        ],
    };

    return (
        <Drawer
            title="Edit Main Menu"
            placement="right"
            width={'50%'}
            visible={visible}
            onClose={resetAndClose}
                destroyOnClose
        >
            <div  style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                minHeight: "100%",
            }}>
            <Form onSubmit={handleUpdate}>
                <div className="row"
                >
                    {inputTypes.fields.map((item, key) => (
                        <div className={item.span} key={key}>
                            <GetEachFormFields {...form} item={item} />
                        </div>
                    ))}
                </div>

                <button className="btn btn-success">UPDATE</button>

                <button
                    type="button"
                    className="btn btn-secondary ms-2"
                    onClick={resetAndClose}
                >
                    Cancel
                </button>
            </Form>
            </div>
        </Drawer>
    );
}

export default Form.create()(EditMainMenu);
